// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Inter-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Inter-SemiBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("SharpGroteskThin25.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: Inter;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	font-weight: 400;
}

@font-face {
	font-family: Inter;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	font-weight: 600;
}

@font-face {
	font-family: Inter;
	font-style: italic;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	font-weight: 600;
}

@font-face {
	font-family: SharpGrotesk;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
	font-weight: 300;
}
`, "",{"version":3,"sources":["webpack://./assets/fonts/fonts.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,4CAA4B;CAC5B,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,4CAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,4CAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,4CAAiC;CACjC,gBAAgB;AACjB","sourcesContent":["@font-face {\n\tfont-family: Inter;\n\tsrc: url(Inter-Regular.woff);\n\tfont-weight: 400;\n}\n\n@font-face {\n\tfont-family: Inter;\n\tsrc: url(Inter-SemiBold.woff);\n\tfont-weight: 600;\n}\n\n@font-face {\n\tfont-family: Inter;\n\tfont-style: italic;\n\tsrc: url(Inter-SemiBoldItalic.woff);\n\tfont-weight: 600;\n}\n\n@font-face {\n\tfont-family: SharpGrotesk;\n\tsrc: url(SharpGroteskThin25.woff);\n\tfont-weight: 300;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
